var links = [].slice.call(document.querySelectorAll('.link'));

links.forEach(function (link) {
    link.addEventListener('click', function (e) {
        if (e.target.tagName !== 'A' && this.hasAttribute('data-href')) {
            var href = this.dataset.href;

            if (href.indexOf(location.host) == -1)
                window.open(href);
            else
                window.location.href = href;
        }
    });
});


var sidebarItems = [].slice.call(document.querySelectorAll('.sidebar-links > li button'));

sidebarItems.forEach(function(sidebarItem) {
    sidebarItem.addEventListener('click', function() {
        var child = this.nextSibling,
            open = this.parentNode.parentNode.querySelector('.open + ul'),
            animation = window.getComputedStyle(child).display == 'block' ? 'slideUp' : 'slideDown';

        if(open && open != child && !open.contains(this)) {
            Velocity(open, 'slideUp', {duration: 150});
            open.previousSibling.classList.remove('open');
        }

        Velocity(child, animation, {duration: 150});

        this.classList.toggle('open');
    });
});

/*
* Sidebar anchor links
* */

var anchorDiv = document.querySelector('.show-anchors');

if (anchorDiv) {
    var slideBarLinksUl = anchorDiv.querySelector('.sidebar-links'),
        activeLink = slideBarLinksUl.querySelector('.active').parentNode;

    // Create the ul element
    var ul = document.createElement('ul');

    // Get the div element
    var divContent = document.getElementById('content');

// Get all headings inside the div
    var headings = divContent.querySelectorAll(':scope > h3,:scope > h4,:scope > h5,:scope > h6');

// Loop through the headings and do something with each one
    for (var i = 0; i < headings.length; i++) {
        var heading = headings[i];
        // Do something with the heading, such as printing its text content
        heading.id = convertToSlug(heading.textContent);
        var li = document.createElement('li'),
        aTag = document.createElement('a');
        aTag.textContent = heading.textContent;
        aTag.href = "#"+convertToSlug(heading.textContent);
        aTag.className = 'scroll-link';

        li.appendChild(aTag);
        ul.appendChild(li);
    }


// Append the ul element to the document body or any other desired element
    ul.className = 'anchorSubLinks';
    activeLink.appendChild(ul);

    // Add scroll effect to the links
    var scrollLinks = [].slice.call(slideBarLinksUl.querySelectorAll('.scroll-link'));


    scrollLinks.forEach(function(scrollLink) {
        scrollLink.addEventListener('click', function(e) {
            if(this.tagName == 'A')
                e.preventDefault();

            scrollLinks.forEach(function(scrollLink1) {
                scrollLink1.classList.remove('active');
            })

            scrollToElement(document.querySelector(this.getAttribute('href')));
            scrollLink.classList.add('active');
        });
    });

    var headingLoad = function() {

        headings.forEach(function (header) {

            if (isInMiddle(header)) {
                scrollLinks.forEach(function(scrollLink) {

                    if(header.id === scrollLink.getAttribute('href').replace("#" ,'')){
                        scrollLinks.forEach(function(scrollLink1) {
                            scrollLink1.classList.remove('active');
                        })
                        scrollLink.classList.add('active');
                    }
                })

            }
        })

    }

    document.addEventListener('scroll', headingLoad);


}

function isInMiddle(element) {
    const rect = element.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // Calculate the vertical middle of the screen
    const middleOfScreen = (windowHeight / 2) - headerHeight;

    // Check if the bottom of the element is below the top of the middle
    // and the top of the element is above the bottom of the middle
    return rect.bottom > middleOfScreen && rect.top < middleOfScreen;
}

function convertToSlug(str) {
    return str
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
}
